export enum VatTableItemContext {
    DocumentCurrency = 1,
    SystemCurrency
}
